"use client";

import { Routes } from "@/api";
import {
  AuthDialog,
  useAuthDialogProps,
} from "@/components/authentication/auth-dialog";
import React, { createContext, PropsWithChildren } from "react";

type AuthDialogContextType = ReturnType<typeof useAuthDialogProps>;

const AuthDialogContext = createContext<AuthDialogContextType | undefined>(
  undefined,
);

export function AuthDialogProvider({ children }: PropsWithChildren) {
  const authDialogProps = useAuthDialogProps();

  return (
    <AuthDialogContext.Provider value={authDialogProps}>
      {children}
      <AuthDialog {...authDialogProps} callbackUrl={Routes.USER_HOME} />
    </AuthDialogContext.Provider>
  );
}

export function useAuthDialogContext() {
  const context = React.useContext(AuthDialogContext);
  if (context === undefined) {
    throw new Error(
      `useAuthDialogContext must be used within a AuthDialogProvider`,
    );
  }
  return context;
}
